import netsSpeedParkFab from './nets-speed-park-fab';

export default angular
  .module('app.speedParkFab', [])
  .component('netsSpeedParkFab', netsSpeedParkFab);
